import React, { Component } from 'react';
import './sensorSetting.less';
import { Switch } from 'antd';
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from "../../../../../utils/spUtils";
import { getDevicesByGroupId } from '../../../../../utils/meshUtils';
import { convertSecondsToTime } from '../../../../../utils/dataUtils';
import { sendOpcode_group_light, sendOpcode_group_onoff, sendOpcode_identify, sendOpcode_group_state, sendOpcode_devices_state } from '../../../../../utils/opcodeUtils';
import light_normal3 from "../../../../../imgs/mesh/light_normal3.png";
import btn_on from "../../../../../imgs/mesh/btn_on.png";
import btn_off from "../../../../../imgs/mesh/btn_off.png";
import montion from "../../../../../imgs/item/montion.png";
import daylight from "../../../../../imgs/item/daylight.png";
import vacant from "../../../../../imgs/item/vacant.png";
import detection_area from "../../../../../imgs/item/detection_area.png";
import max_dim from "../../../../../imgs/item/max_dim.png";
import hold_time from "../../../../../imgs/item/hold_time.png";
import dim_level from "../../../../../imgs/item/dim_level.png";
import period from "../../../../../imgs/item/period.png";
import threshold from "../../../../../imgs/item/threshold.png";
import photocell from "../../../../../imgs/item/photocell.png";
import harvesting from "../../../../../imgs/item/harvesting.png";
import devices from "../../../../../imgs/item/devices.png";
import btn_refresh from "../../../../../imgs/btn/btn_refresh.png";
import arrow_right from "../../../../../imgs/btn/arrow_right.png";
import arrow_down from "../../../../../imgs/btn/arrow_down.png";
import eye_show from "../../../../../imgs/btn/eye_show.png";
import wifi_4 from "../../../../../imgs/mesh/wifi_4.png";
import wifi_0 from "../../../../../imgs/mesh/wifi_0.png";
import DH_background from "../../../../../imgs/btn/DH_background.png";
import { IsDevicePir } from '../../../../../utils/pidUtils';
import { SET_ControlPageDetailPage_DIALOG_HIDE, SPIN_DIALOG_SHOW, SPIN_DIALOG_HIDE } from "../../../../../const/infoConst"


export default class SensorSetting extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOn: true,
            cctLevel: 50,
            cctLevelValue: 1000,
            dimLevel: 50,
            groupInfo: '',
            cctModeArray: [],
            motionSensorEnabled: false,
            detectionArea: 'Medium',
            maxDim: '50%',
            holdTime_min: '150',
            holdTime_s: '150',
            standbyDim: '30%',
            standbyPeriod_s: '0s',
            standbyPeriod_min: '0s',
            daylightSensor: false,
            daylightThreshold: '200Lux',
            dhEnabled: false,
            checked: false, //group是否展开
            devices: [], //group数据
            sensor_switch: false,
            daylight_switch: false,
            vacant_switch: false,
            isPhotoCell: false,
            isDaylightHarvesting: false,
        }
    }



    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        PubSub.unsubscribe("mqttGroupState")
        PubSub.subscribe('mqttGroupState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
        meshLog('更新灯的状态',);
        PubSub.unsubscribe("mqttDeviceState")
        PubSub.subscribe('mqttDeviceState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
    }

    updateGroupUI() {
        meshLog('sensorSetting渲染第一步', this.props);
        const groupList = JSON.parse(SPGet("groupList"))
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        const cctModeArray = groupInfo.cctModeArray
        const cctLevelValue = ((cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * (groupInfo.cctLevel) / 400) + cctModeArray[0]
        const motionModel = groupInfo.motionModel
        let detectionArea = ''
        if (motionModel.detectionSensitivity == 0) {
            detectionArea = 'Low'
        } else if (motionModel.detectionSensitivity == 1) {
            detectionArea = 'Medium'
        } else {
            detectionArea = 'High'
        }
        const daylightModel = groupInfo.daylightModel
        meshLog('groupInfo.isOnOff 104', motionModel.isEnabled);
        this.setState({
            groupInfo: groupInfo,
            cctModeArray: cctModeArray,
            cctLevel: groupInfo.cctLevel,
            cctLevelValue: cctLevelValue,
            dimLevel: groupInfo.dimLevel,
            isOn: groupInfo.isOnOff,
            detectionArea: detectionArea,
            motionSensorEnabled: motionModel.isEnabled,
            holdTime_min: convertSecondsToTime(motionModel.holdTime)[0],
            holdTime_s: convertSecondsToTime(motionModel.holdTime)[1],
            maxDim: motionModel.maxLight + '%',
            standbyPeriod_min: convertSecondsToTime(motionModel.standbyPeriod)[0],
            standbyPeriod_s: convertSecondsToTime(motionModel.standbyPeriod)[1],
            standbyDim: motionModel.standbyDimLevel + '%',
            daylightSensor: daylightModel.isEnabled,
            daylightThreshold: daylightModel.threshold + 'fc',
            isPhotoCell: daylightModel.isPhotoCell,
            isDaylightHarvesting: daylightModel.isDaylightHarvesting,
            // groupDevices: groupDevices,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })
    }

    handleToggle = (key) => {
        this.setState((prev) => ({ [key]: !prev[key] }));
        sendOpcode_group_onoff(key);
    };

    //原本的处理方法
    handleChange = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
        if (key == 'isOn') {
            const isOn = this.state.isOn
            this.setState({
                isOn: !isOn
            });
            sendOpcode_group_light(key, !isOn);
        } else {
            sendOpcode_group_light(key, value);
            this.setState({ [key]: value });
        }

    };

    handleChange1 = (key, value) => {
        //边输入边赋值
        meshLog('handleChange1value', value);
        meshLog('key', key);
        this.setState({ [key]: value });

    };
    //处理方法
    handleChange2 = (key, value) => {
        //边输入边赋值 只改状态，不发送指令，，统一到最后修改
        meshLog('handleChange2handleChange2',);
        if (key == 'detectionArea') {
            this.setState({ [key]: value });
        } else {
            if (/^\d*$/.test(value)) { // 确保输入为数字序列或空字符串结束
                let valueR
                if (key == 'maxDim' || key == 'standbyDim') {
                    if (value > 100) {
                        valueR = '100'
                    } else {
                        valueR = value; // 添加内容到输入框
                    }
                    this.setState({ [key]: valueR });
                } else if (key == 'holdTime_s' || key == 'standbyPeriod_s') {
                    if (value > 60) {
                        valueR = '60'
                    } else {
                        valueR = value; // 添加内容到输入框
                    }
                    // meshLog('前端显示的数据', valueX);
                    this.setState({ [key]: valueR });
                } else if (key == 'holdTime_min' || key == 'standbyPeriod_min') {
                    if (value > 120) {
                        valueR = '120'
                    } else {
                        valueR = value; // 添加内容到输入框
                    }
                    // meshLog('前端显示的数据', valueX);
                    this.setState({ [key]: valueR });
                }
                else if (key == 'daylightThreshold') {
                    if (value > 200) {
                        valueR = '200'
                    } else {
                        valueR = value; // 添加内容到输入框
                    }
                    this.setState({ [key]: valueR });
                } else {
                    meshLog('123123123',);

                }
                // 这里可以调用其他函数或发送数据等
            } else {
                // 如果不符合条件，可以清除或修改已输入的内容（可选）
                this.setState({ [key]: 0 });
            }
            // this.setState({ [key]: value });
        }

    };
    vacantOk = (key, value) => {
        //发上面的6个指令


        meshLog('vacantOk');
        const {
            detectionArea,
            maxDim,
            holdTime_s,
            holdTime_min,
            standbyDim,
            standbyPeriod_s,
            standbyPeriod_min,
            daylightThreshold,
        } = this.state;
        let holdTime = parseInt(holdTime_s.replace("s", "")) + parseInt(holdTime_min.replace("min", "")) * 60 + 's'
        let standbyPeriod = parseInt(standbyPeriod_s.replace("s", "")) + parseInt(standbyPeriod_min.replace("min", "")) * 60 + 's'
        sendOpcode_group_light('detectionArea', detectionArea);
        setTimeout(() => {
            sendOpcode_group_light('maxDim', maxDim);
        }, 300)
        setTimeout(() => {
            sendOpcode_group_light('holdTime', holdTime);
        }, 600)
        setTimeout(() => {
            sendOpcode_group_light('standbyDim', standbyDim);
        }, 900)
        setTimeout(() => {
            sendOpcode_group_light('standbyPeriod', standbyPeriod);
        }, 1200)
        setTimeout(() => {
            sendOpcode_group_light('daylightThreshold', daylightThreshold);
        }, 1500)

        PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
        setTimeout(() => {
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        }, 2000)

        // sendOpcode_group_light('detectionArea', detectionArea);
        // sendOpcode_group_light('maxDim', maxDim);
        // sendOpcode_group_light('holdTime', holdTime);
        // sendOpcode_group_light('standbyDim', standbyDim);
        // sendOpcode_group_light('standbyPeriod', standbyPeriod);
        // sendOpcode_group_light('daylightThreshold', daylightThreshold);

    };

    handleMouseUp = (key, value) => {
        //边输入边赋值 鼠标离开发指令，主要是针对调光调色
        meshLog('handleMouseUphandleMouseUp', value);
        sendOpcode_group_light(key, value);
    };

    handleKeyUp = (event, key, value) => {
        if (event.key === 'Enter') {
            // 在这里执行你的方法
            meshLog('event', event);
            meshLog('key', key);
            console.log('Input value:', value);
            if (/^\d*$/.test(value)) { // 确保输入为数字序列或空字符串结束
                let valueR
                if (key == 'maxDim' || key == 'standbyDim') {
                    if (value > 100) {
                        valueR = '100%'
                    } else {
                        valueR = value + '%'; // 添加内容到输入框
                    }
                    this.setState({ [key]: valueR });
                } else if (key == 'holdTime_s' || key == 'standbyPeriod_s') {
                    let valueX
                    if (value > 60) {
                        valueX = 60 + 's'
                    } else {
                        valueX = value + 's'
                    }
                    // meshLog('前端显示的数据', valueX);
                    this.setState({ [key]: valueX });
                } else if (key == 'holdTime_min' || key == 'standbyPeriod_min') {
                    let valueX = value + 'min'
                    valueR = value + 'min'
                    // meshLog('前端显示的数据', valueX);
                    this.setState({ [key]: valueX });
                }
                else if (key == 'daylightThreshold') {
                    valueR = value + 'fc'; // 添加内容到输入框
                    this.setState({ [key]: valueR });
                }
                // 这里可以调用其他函数或发送数据等
                //更新UI
                // sendOpcode_group_light(key, valueR);
                const groupList = JSON.parse(SPGet("groupList"))
                const groupInfoLast = JSON.parse(SPGet("groupInfo"))
                let groupInfo = groupList.find(item => item.groupID == groupInfoLast.groupID)
                const cctModeArray = groupInfo.cctModeArray
                if (key == 'cctLevel') {
                    const cctLevelValue = Math.round(((cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * (value) / 400) + cctModeArray[0])
                    this.setState({ cctLevelValue: cctLevelValue });
                } else if (key == 'cctLevelValue') {
                    const cctLevel = Math.round(((value - cctModeArray[0]) / (cctModeArray[cctModeArray.length - 1] - cctModeArray[0]) * 400))
                    this.setState({ cctLevel: cctLevel });
                }

            } else {
                // 如果不符合条件，可以清除或修改已输入的内容（可选）
                value = 0; // 仅保留数字，移除非数字字符（如果需要）
                meshLog('valuevalue', value);
                let valueR
                if (key == 'maxDim' || key == 'standbyDim') {
                    valueR = value + '%'; // 添加内容到输入框
                    this.setState({ [key]: valueR });
                } else if (key == 'holdTime_s' || key == 'standbyPeriod_s') {
                    let valueX
                    valueX = value + 's'
                    // meshLog('前端显示的数据', valueX);
                    this.setState({ [key]: valueX });
                } else if (key == 'holdTime_min' || key == 'standbyPeriod_min') {
                    let valueX = value + 'min'
                    valueR = value + 's'
                    // meshLog('前端显示的数据', valueX);
                    this.setState({ [key]: valueX });
                }
                else if (key == 'daylightThreshold') {
                    valueR = value + 'fc'; // 添加内容到输入框
                    this.setState({ [key]: valueR });
                }

            }

        }

    }
    //group展开
    groupArrowClick = () => {
        let mm = this.state.checked;
        this.setState({ checked: !mm });
    }

    //灯identify
    showHightLight = (device) => {
        sendOpcode_identify(device);
    }

    //switch开关
    sensorSwitch = (checked) => {
        this.setState({ motionSensorEnabled: checked });
        meshLog('motionSensorEnabled', checked);
        sendOpcode_group_onoff("motionSensorEnabled");
    }
    daylightSwitch = (checked) => {
        this.setState({ daylightSensor: checked });
        sendOpcode_group_onoff("daylightSensor");
    }
    vacantSwitch = (checked) => {
        this.setState({ vacant_switch: checked });
        if (checked == true) {
            sendOpcode_group_onoff("vacantSwitch");
        } else {
            sendOpcode_group_onoff("vacantSwitch2");
        }

    }
    isPhotoCell = (checked) => {
        this.setState({ isPhotoCell: checked });
        meshLog('写方法sendOpcode_group_light参考这个，参考开关灯 0x1084+00/01 = Photocell',);
        const key = 'isPhotoCell'
        sendOpcode_group_onoff(key)
    }
    isDaylightHarvesting = (checked) => {
        this.setState({ isDaylightHarvesting: checked });
        const key = 'isDaylightHarvesting'
        meshLog('写方法sendOpcode_group_light参考这个参考开关灯 0x10A1+00/01 = DH',);
        sendOpcode_group_onoff(key)
    }

    controlPageDetailContainer = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制ControlPageDetailPage弹框显示
    }

    controlRefreshDevices = () => {
        //获取单灯的状态，通过网关来返回的
        sendOpcode_devices_state()
        meshLog('获取单灯的状态',);
    }

    vacantCancel = () => {
        //关闭sensorSettings界面，打开sensor界面
        PubSub.publish('gotoSensorset', '')//显示Sensorset界面

    };

    render() {
        const {
            isOn,
            cctLevel,
            motionSensorEnabled,
            detectionArea,
            maxDim,
            holdTime_s,
            holdTime_min,
            standbyDim,
            standbyPeriod_s,
            standbyPeriod_min,
            daylightSensor,
            daylightThreshold,
            dhEnabled,
            groupInfo,
            cctModeArray,
            dimLevel,
            cctLevelValue
        } = this.state;

        return (
            <div className="sensor_Settings-container">
                <div className="ui_grey_bg" />
                {/* 组名和电源按钮 */}
                <div className="sensor_Settings-popup">

                    <div style={{ marginTop: "20px" }}>
                        <span style={{ marginLeft: "20px", fontSize: "18px" }}>sensor Settings</span>
                    </div>
                    <div className="line_space"></div>
                    {/* Sensor Mode 部分 */}
                    <div style={{ height: "565px", overflow: "auto" }}>
                        <div className="motion-section">
                            <div className="item-header">
                                <div className="sensor-title">
                                    <img src={montion} />
                                    <span className="fontsize">Sensor Mode</span>
                                </div>
                                <Switch defaultChecked={motionSensorEnabled} onChange={this.sensorSwitch} />
                            </div>
                            {/* 详情 */}
                            <div className='switchItem' style={{ display: motionSensorEnabled ? "flex" : "none" }}>
                                <div className="detection_area">
                                    <div className="sensor-title">
                                        <img src={detection_area} />
                                        <span className="fontsize">Detection Area</span>
                                    </div>
                                    <div className="box">
                                        <select value={detectionArea} onChange={(e) => this.handleChange2('detectionArea', e.target.value)}>
                                            <option>Low</option>
                                            <option>Medium</option>
                                            <option>High</option>
                                        </select></div>
                                </div>
                                <div className="max_dim">
                                    <div className="sensor-title">
                                        <img src={max_dim} />
                                        <span className="fontsize">Max Dim</span>
                                    </div>
                                    <div className="box">
                                        {/*   */}
                                        <input style={{ width: 62 }} type="text" value={maxDim} onKeyUp={(event) => this.handleKeyUp(event, 'maxDim', event.target.value)} onChange={(e) => this.handleChange2('maxDim', e.target.value)} />
                                    </div>
                                </div>
                                <div className="hold_time">
                                    <div className="sensor-title">
                                        <img src={hold_time} />
                                        <span className="fontsize">Hold Time</span>
                                    </div>
                                    <div className="box">
                                        <input style={{ width: 35, marginRight: 10 }} type="text" value={holdTime_min} onKeyUp={(event) => this.handleKeyUp(event, 'holdTime_min', event.target.value)} onChange={(e) => this.handleChange2('holdTime_min', e.target.value)} />
                                        <input style={{ width: 35 }} type="text" value={holdTime_s} onKeyUp={(event) => this.handleKeyUp(event, 'holdTime_s', event.target.value)} onChange={(e) => this.handleChange2('holdTime_s', e.target.value)} />
                                    </div>
                                </div>
                                <div className="standby_dim_level">
                                    <div className="sensor-title">
                                        <img src={dim_level} />
                                        <span className="fontsize">Standby Dim Level</span>
                                    </div>
                                    <div className="box">
                                        <input style={{ width: 62 }} type="text" value={standbyDim} onKeyUp={(event) => this.handleKeyUp(event, 'standbyDim', event.target.value)} onChange={(e) => this.handleChange2('standbyDim', e.target.value)} />
                                    </div>
                                </div>
                                <div className="standby_period">
                                    <div className="sensor-title">
                                        <img src={period} />
                                        <span className="fontsize">Standby Period</span>
                                    </div>
                                    <div className="box">
                                        <input style={{ width: 35, marginRight: 10 }} type="text" value={standbyPeriod_min} onKeyUp={(event) => this.handleKeyUp(event, 'standbyPeriod_min', event.target.value)} onChange={(e) => this.handleChange2('standbyPeriod_min', e.target.value)} />
                                        <input style={{ width: 35 }} type="text" value={standbyPeriod_s} onKeyUp={(event) => this.handleKeyUp(event, 'standbyPeriod_s', event.target.value)} onChange={(e) => this.handleChange2('standbyPeriod_s', e.target.value)} />

                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* Daylight Sensor */}
                        <div className="daylight-section">
                            <div className="item-header">
                                <div className="sensor-title">
                                    <img src={daylight} />
                                    <span className="fontsize" >Daylight Sensor</span>
                                </div>
                                <Switch defaultChecked={daylightSensor} onChange={this.daylightSwitch} />
                            </div>
                            {/* 详情 */}
                            <div className='switchItem' style={{ display: daylightSensor ? "flex" : "none" }}>
                                <div className="threshold">
                                    <div className="sensor-title">
                                        <img src={threshold} />
                                        <span className="fontsize" >Daylight Threshold</span>
                                    </div>
                                    <div className="box">
                                        <input style={{ width: 62 }} type="text" value={daylightThreshold} onKeyUp={(event) => this.handleKeyUp(event, 'daylightThreshold', event.target.value)} onChange={(e) => this.handleChange2('daylightThreshold', e.target.value)} />
                                    </div>
                                </div>
                                <div className="photocell">
                                    <div className="sensor-title">
                                        <img src={photocell} />
                                        <span className="fontsize">Photocell</span>
                                    </div>
                                    <div className="box">
                                        <Switch defaultChecked={false} onChange={this.isPhotoCell} />
                                    </div>
                                </div>
                                <div className="harvesting">
                                    <div className="sensor-title">
                                        <img src={harvesting} />
                                        <span className="fontsize">Daylight Harvesting</span>
                                    </div>
                                    <div className="box">
                                        <Switch defaultChecked={false} onChange={this.isDaylightHarvesting} />
                                    </div>

                                </div>
                                <div style={{ display: this.state.isDaylightHarvesting ? "flex" : "none", marginTop: 10 }}>
                                    <input
                                        type="range"
                                        min="0"
                                        max="100"
                                        value={dimLevel}
                                        className="slider"
                                        onMouseUp={(e) => this.handleMouseUp('dimLevel', parseInt(e.target.value))}
                                        onChange={(e) => this.handleChange1('dimLevel', parseInt(e.target.value))}
                                    />
                                    <img style={{ width: 32, height: 32, marginLeft: 50, }} src={DH_background} onClick={() => this.handleToggle('DaylightHarvesting')} />
                                </div>
                            </div>
                        </div>
                        {/* Vacant*/}
                        <div className="vacant-section">
                            <div className="item-header">
                                <div className="sensor-title">
                                    <img src={vacant} />
                                    <span className="fontsize">Vacant</span>
                                </div>
                                <Switch defaultChecked={false} onChange={this.vacantSwitch} />
                            </div>
                        </div>

                        {/* 底部按钮 */}
                        <div className="control-footer">
                            <button className='cancelBtn' onClick={() => this.vacantCancel()}>Cancel</button>

                            <button className='okBtn' onClick={() => this.vacantOk()} >Confirm</button>
                        </div>
                    </div>


                </div>


            </div >
        );
    }
}
